import { getCookie, setCookie, deleteCookie } from "cookies-next";

export const LANGUAGE_COOKIE = "selectedLangDot";
export const DEVICE_LANGUAGE_COOKIE = "deviceLangDot";

export const getSelectedLanguage = () => {
  return getCookie(LANGUAGE_COOKIE) || "en-us";
};

export const setSelectedLanguage = (lang: string) => {
  setCookie(LANGUAGE_COOKIE, lang, {
    maxAge: 60 * 60 * 24 * 365,
    path: "/",
  });
};

export const clearLanguage = () => {
  deleteCookie(LANGUAGE_COOKIE);
  deleteCookie(DEVICE_LANGUAGE_COOKIE);
};


/**
 * Device Language (browser default)
 */
export const getDeviceLanguage = () => {
  let lang = getCookie(DEVICE_LANGUAGE_COOKIE);

  if (!lang && typeof navigator !== "undefined") {
    lang = navigator.language?.toLowerCase() || "en-us";

    setCookie(DEVICE_LANGUAGE_COOKIE, lang, {
      maxAge: 60 * 60 * 24 * 365, // 1 year
      path: "/",
    });
  }

  return lang || "en-us";
};